import React, { useState, useEffect } from "react";
import { AccountStyle } from "./Account.styled";
import TotalNoCard from "../../components/TotalNoCard/TotalNoCard";
import PercentageCard from "../../components/PercentageCard/PercentageCard";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  AccountDataAPI,
  getBaseStationDataAPI,
  getBaseStationDataAPI1,
  getBeaconDataAPI1,
  getBeaconDataAPI2,
  getUserOS,
  updateAccountAPI,
  updateAccountPassword,
} from "../../api/AccountApi";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { checkStatusExpiry } from "../../common/checkStatusExpiry";
import { useDB } from "../../context/DynamoDBContext";
import DeleteButton from "../../components/Buttons/DeleteButton";
import { useReload } from "../../context/ReloadContext";
import StatusEnum from "../../common/StatusEnum";
import { CacheTime, StaleTime } from "../../common/StaleTime";
import useInternetConnectivity from "../../hooks/useInternetConnectivity";
import Internet from "../../components/internet/Internet";
import { useSelector } from "react-redux";
import ExportData from "../../components/Export/ExportData";
import Popup from "../../components/Modals/Modal";
import ResetModal from "../../components/ResetPasswordModal/ResetModal";
import AccountCharts from "../../components/accountCharts/AccountCharts";
import NoDataChart from "../../components/NoDataChart/NoDataChart";
import { PageStyle } from "../../styles/MainBodyStyles";

const Account = ({ title, id }) => {
  const { reload } = useReload();
  const isOnline = useInternetConnectivity();
  const navigateRed = useSelector((state) => state.navigateRed);
  const queryClient = useQueryClient();
  const { dynamoDBClient } = useDB();
  const [userName, setUserName] = useState("");
  const [userDate, setUserDate] = useState("1/1/2023");
  const [userID, setUserID] = useState("xxx-xxx-xxx");
  const [userActiveBaseStations, setUserActiveBaseStations] = useState("0");
  const [userActiveBeacon, setUserActiveBeacon] = useState("0");
  const [enableAccountAPI, setEnableAccountAPI] = useState(false);
  const [enableAccountAPI2, setEnableAccountAPI2] = useState(false);
  const [enableAccountAPI3, setEnableAccountAPI3] = useState(false);
  const [enableOsAPI, setEnableOsAPI] = useState(false);
  const [holdAccountStatus, setHoldAccountStatus] = useState(true);
  const [password, setPassword] = useState("");
  const [updateAccount, setUpdateAccount] = useState(false);
  const [updateAccountPasswordAPI, setUpdateAccountPasswordAPI] =
    useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [os, setOs] = useState("Not Available");
  const [appVersion, setAppVersion] = useState("Not Available");
  const [osVersion, setOsVersion] = useState("Not Available");
  const [bSCounts, setBSCounts] = useState({
    online: 0,
    offline: 0,
    snoozed: 0,
  });
  const [beaconCounts, setBeaconCounts] = useState({
    online: 0,
    offline: 0,
    snoozed: 0,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["AccountDataAPI", id]);
      queryClient.fetchQuery(["BaseStationCountData1", id]);
      queryClient.fetchQuery(["BeaconCountData1", id]);
      queryClient.fetchQuery(["osData", id]);
    }
  }, [reload]);

  const handleError = (type) => {
    if (type === "AccountDataAPI") {
      toast.error("Unable to get User Details", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "osData") {
      toast.error("Unable to get User OS Details", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "UpdateAccount") {
      setUpdateAccount(false);
      toast.error("Unable to set Account ON-HOLD", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "UpdateAccountPassword") {
      setEnableAccountAPI(false);
      setModal2(false);
      toast.error("Unable to Reset Password", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  useEffect(() => {
    if (dynamoDBClient !== null) {
      setEnableAccountAPI(true);
      setEnableOsAPI(true);
    } else {
      setEnableAccountAPI(false);
    }
  }, [dynamoDBClient]);

  const setAccountData = (data) => {
    setHoldAccountStatus(data.AccountHold);
    setUserName(() => {
      if (data.FirstName !== "") {
        return `${data.FirstName} ${data.LastName}`;
      } else {
        return "";
      }
    });
    setUserDate(() => {
      if (data.DateSubmitted !== "") {
        const date = moment.utc(data.DateSubmitted, "YYYY-MM-DD HH:mm:ss Z");
        const formattedDate = date.format("DD-MMM-YYYY");
        return formattedDate;
      } else {
        return "Not Available";
      }
    });
    setUserID(data.Email);
  };

  const { error: userErr, data: userData } = useQuery({
    queryKey: ["AccountDataAPI", id],
    queryFn: () => AccountDataAPI(dynamoDBClient, id),
    enabled: enableAccountAPI,
    onSuccess: (data) => {
      setAccountData(data);
    },
    onError: (error) => {
      console.log("AccountDataAPI :", error);
      handleError("AccountDataAPI");
    },
  });

  // if(userErr){
  //   toast.error("Unable to get User Details",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }

  const calculateBaseStation = (data = []) => {
    setEnableAccountAPI3(false);
    setUserActiveBaseStations(data.length);
    const gatewayStatusCounts = {
      online: 0,
      offline: 0,
      snoozed: 0,
    };
    if (data.length !== 0) {
      data.forEach((item) => {
        const bSStatus = item.Status;
        if (bSStatus === StatusEnum.online) {
          const isGreaterTime = checkStatusExpiry(item.DateUpdated);
          if (isGreaterTime) {
            gatewayStatusCounts[StatusEnum.offline]++;
          } else {
            gatewayStatusCounts[StatusEnum.online]++;
          }
        } else {
          gatewayStatusCounts[StatusEnum.snoozed]++;
        }
      });
      setBSCounts(gatewayStatusCounts);
    } else {
      setBSCounts(gatewayStatusCounts);
    }
  };

  const { data: extraa2 } = useQuery({
    queryKey: ["BaseStationCountData1", id],
    queryFn: () => getBaseStationDataAPI1(dynamoDBClient, id),
    enabled: enableAccountAPI,
    onSuccess: (data) => {
      if (data) {
        setEnableAccountAPI3(true);
        queryClient.fetchQuery(["BaseStationCountData2", id], {
          queryFn: () => getBaseStationDataAPI(dynamoDBClient, id, data),
        });
      } else {
        calculateBaseStation([]);
      }
    },
  });
  const { data: countBSData } = useQuery({
    queryKey: ["BaseStationCountData2", id],
    queryFn: () => getBaseStationDataAPI(dynamoDBClient, id, extraa2),
    enabled: enableAccountAPI3,
    onSuccess: (data = []) => {
      calculateBaseStation(data);
    },
  });

  const calculateBeaconData = (data = []) => {
    setEnableAccountAPI2(false);
    setUserActiveBeacon(data.length);
    const beaconStatusCounts = {
      online: 0,
      offline: 0,
      snoozed: 0,
    };
    if (data.length !== 0) {
      data.forEach((item) => {
        const beaconStatus = item.BeaconStatus;
        if (beaconStatus === StatusEnum.online) {
          const isGreaterTime = checkStatusExpiry(item.DateUpdated);

          if (isGreaterTime) {
            beaconStatusCounts[StatusEnum.offline]++;
          } else {
            beaconStatusCounts[beaconStatus]++;
          }
        } else {
          beaconStatusCounts[beaconStatus]++;
        }
      });
      setBeaconCounts(beaconStatusCounts);
    } else {
      setBeaconCounts(beaconStatusCounts);
    }
  };

  const { data: extra } = useQuery({
    queryKey: ["BeaconCountData1", id],
    queryFn: () => getBeaconDataAPI1(dynamoDBClient, id),
    enabled: enableAccountAPI,
    onSuccess: (data) => {
      if (data) {
        setEnableAccountAPI2(true);
        queryClient.fetchQuery(["BeaconCountData2", id], {
          queryFn: () => getBeaconDataAPI2(dynamoDBClient, id, data),
        });
      } else {
        calculateBeaconData([]);
      }
    },
  });
  const { data: countBData, status: countBDataStatus } = useQuery({
    queryKey: ["BeaconCountData2", id],
    queryFn: () => getBeaconDataAPI2(dynamoDBClient, id, extra),
    enabled: enableAccountAPI2,
    onSuccess: (data = []) => {
      calculateBeaconData(data);
    },
  });

  const { status: updateAccountStatus } = useQuery({
    queryKey: ["UpdateAccount", id],
    enabled: updateAccount,
    queryFn: () => updateAccountAPI(dynamoDBClient, id),
    onSuccess: (data) => {
      toast.success("Account set ON-HOLD successfully", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
      setUpdateAccount(false);
      setHoldAccountStatus(data.AccountHold);
    },
    onError: (error) => {
      console.log("UpdateAccount :", error);
      handleError("UpdateAccount");
    },
  });

  // if(updateAccountStatus==="error"){
  //   setUpdateAccount(false)
  //   toast.error("Unable to set Account ON-HOLD",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }

  const calculateOS = (data) => {
    if (data.length > 0) {
      if (data[0]?.MobileDevice) {
        if (data[0].MobileDevice === "iphone") {
          setOs("iOS");
        } else {
          setOs(data[0].MobileDevice);
        }
      } else {
        setOs("Not Available");
      }

      if (data[0]?.Version) {
        setAppVersion(data[0].Version);
      } else {
        setAppVersion("Not Available");
      }
      if (data[0]?.MobileOSVersion) {
        setOsVersion(data[0].MobileOSVersion);
      } else {
        setOsVersion("Not Available");
      }
    }
  };

  const { status: updateAccountPasswordStatus } = useQuery({
    queryKey: ["UpdateAccountPassword", id],
    enabled: updateAccountPasswordAPI,
    queryFn: () => updateAccountPassword(dynamoDBClient, id, password),
    onSuccess: (data) => {
      setUpdateAccountPasswordAPI(false);
      setModal2(false);
      toast.success("Password reset successful", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    },
    onError: (error) => {
      console.log("UpdateAccountPassword :", error);
      handleError("UpdateAccountPassword");
    },
  });
  const { data: osData } = useQuery({
    queryKey: ["osData", id],
    enabled: enableOsAPI,
    queryFn: () => getUserOS(dynamoDBClient, id),
    onSuccess: (data) => {
      calculateOS(data);
    },
    onError: (error) => {
      console.log("osData :", error);
      handleError("osData");
    },
  });

  // if(updateAccountPasswordStatus==="error"){
  //   setEnableAccountAPI(false)
  //   setModal2(false)
  //   toast.error("Unable to Reset Password",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }

  useEffect(() => {
    if (userData) {
      setAccountData(userData);
    }
    if (countBSData) {
      calculateBaseStation(countBSData);
    }
    if (countBData) {
      calculateBeaconData(countBData);
    }

    if (osData) {
      calculateOS(osData);
    }
  }, [userData, countBSData, countBData, osData]);
  return (
    <>
      <Popup
        visible={modal1}
        setVisible={() => setModal1(false)}
        message={"This Action will set the User Account ON-HOLD"}
        onAccept={() => {
          setUpdateAccount(true);
          setModal1(false);
        }}
      />
      <ResetModal
        visible={modal2}
        setVisible={() => setModal2(false)}
        onAccept={(data) => {
          setPassword(data);
          setUpdateAccountPasswordAPI(true);
        }}
      />
      <AccountStyle>
        <PageStyle>
          <ExportData />
          <div
            className={
              navigateRed.sideBar ? "home-container" : "home-container2"
            }
          >
            {!isOnline && <Internet />}
            <HeadingStyle>{userName === "" ? title : userName}</HeadingStyle>
            <div className="main">
              <TotalNoCard heading={"Account Name"} total={userName} />
              <TotalNoCard heading={"Date Created"} total={userDate} />
              <TotalNoCard heading={"User ID"} total={userID} />
              <TotalNoCard heading={"OS"} total={os} />
              <TotalNoCard heading={"Mobile OS Version"} total={osVersion} />
              <TotalNoCard heading={"App Version"} total={appVersion} />
              <TotalNoCard
                heading={"Total No of Active BaseStation"}
                total={userActiveBaseStations}
              />
              <TotalNoCard
                heading={"Total No of Active Beacons"}
                total={userActiveBeacon}
              />
            </div>
            <HeadingStyle>
              System&ensp;<i className="bi bi-clipboard2-data heading-icon"></i>
            </HeadingStyle>
            <div className="main2">
              {userActiveBaseStations !== 0 ? (
                <AccountCharts
                  datasetIdKey={id}
                  data={bSCounts}
                  module="Base Stations"
                />
              ) : (
                <NoDataChart datasetIdKey={id} module="Base Stations" />
              )}
              {userActiveBeacon !== 0 ? (
                <AccountCharts
                  datasetIdKey={id}
                  data={beaconCounts}
                  module="Beacons"
                />
              ) : (
                <NoDataChart datasetIdKey={id} module="Beacons" />
              )}
            </div>
            <div className="main">
              <PercentageCard
                heading={"Total No of Active Base Stations Reporting Online"}
                total={bSCounts.online}
              />
              <PercentageCard
                heading={"Total No of Active Beacon Reporting Online"}
                total={beaconCounts.online}
              />
              <PercentageCard
                heading={"Total No of Active Base Stations Reporting Offline"}
                total={bSCounts.offline}
              />
              <PercentageCard
                heading={"Total No of Active Beacon Reporting Offline"}
                total={beaconCounts.offline}
              />
              <PercentageCard
                heading={"Total No of Active Base Stations Reporting Snooze"}
                total={bSCounts.snoozed}
              />
              <PercentageCard
                heading={"Total No of Active Beacon  Reporting Snooze"}
                total={beaconCounts.snoozed}
              />
            </div>
            <DeleteButton
              btnText="Reset Password"
              onClick={() => setModal2(true)}
            />
            <div className="main btn-row">
              {/* <DeleteButton
                  btnText='SET Account ON-HOLD'
                  onClick={()=>setModal1(true)}
                  disabled={updateAccount || !holdAccountStatus}
                /> */}
            </div>
          </div>
        </PageStyle>
      </AccountStyle>
    </>
  );
};

export default Account;
